module.exports = __webpack_public_path__ + "998bf875faaa9330f2e13e6710d22ecf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/spider-s.png
// module id = 2944
// module chunks = 0